import AppointmentWlist from './AppointmentWlist'

export default AppointmentWlist